/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import {
  TableHeader,
  ColumnDefinitionMobileHidden,
} from '@atlassian/bitbucket-pageable-table';
import { media } from '@atlassian/bitkit-responsive';

const FIX_OUTLINE_SHIFT = token('space.050');

export const CommitsContainer = styled.div<{ isDisabled: boolean }>(
  {
    position: 'relative',
    width: '100%',
  },
  ({ isDisabled }) =>
    isDisabled ? 'pointer-events: none; user-select: none' : null
);

export const CommitsWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const FlexContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const AuthorName = styled.div(
  {
    marginLeft: token('space.200'),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  media.upToMedium(`
    display: none;
  `)
);

export const AuthorColumnDefinition = styled(ColumnDefinitionMobileHidden)(
  {
    width: '216px',
  },
  media.upToMedium(`
    width: 36px;
  `)
);

export const CommitHashColumnDefinition = styled(ColumnDefinitionMobileHidden)({
  width: '120px',
});

export const CommentsColumnDefinition = styled(ColumnDefinitionMobileHidden)({
  width: '64px',
});

export const DateColumnDefinition = styled(ColumnDefinitionMobileHidden)({
  width: '120px',
});

export const BuildsColumnDefinition = styled.col({
  width: '64px',
});

export const BuildsTableHeader = styled(TableHeader)({
  textAlign: 'center',
});

export const BuildStatusWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

export const CommitHashWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.100'),
});

export const CommitHash = styled.span({
  fontFamily: token('font.family.code'),
});

export const MessageContainer = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  media.upToLarge(`
    flex-wrap: wrap;
  `)
);

export const CommitInfo = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    justifyContent: 'center',
  },
  media.upToSmall(`
    justify-content: flex-start;
  `)
);

export const CommitMessage = styled.div(
  {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    paddingLeft: FIX_OUTLINE_SHIFT,
    img: {
      maxHeight: '1em',
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      fontSize: 'inherit',
    },
  },
  media.upToMedium(`
    padding-left: 0;
  `),
  media.upToLarge(`
    flex-shrink: 1;
    flex-basis: 60%;
  `)
);

export const ExpandedCommitMessage = styled.div({
  whiteSpace: 'break-spaces',
  paddingTop: '2px',
  'span:not(:first-of-type)': {
    color: token('color.text.subtle'),
  },
});

export const ExpandedWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

export const CommitMessageHeaderWrapper = styled.div(
  {
    paddingLeft: FIX_OUTLINE_SHIFT,
  },
  media.upToMedium(`
    padding-left: 0;
  `)
);

export const ShowMoreBtnContainer = styled.div({
  width: '100%',
});

export const CommitSelectorOption = styled.tr<{
  isFocused?: boolean;
  isMergeCommit?: boolean;
}>(
  ({ isFocused }) =>
    isFocused ? `background-color: ${token('color.background.input')}` : null,
  ({ isMergeCommit }) => (isMergeCommit ? 'opacity: 0.7' : null),
  {
    '&:hover, &:focus': {
      backgroundColor: token('color.background.input.hovered'),
      boxShadow: token('elevation.shadow.raised'),
      borderRadius: token('radius.small'),
    },
  }
);

export const CommitLabel = styled.div({
  cursor: 'default',
  paddingLeft: token('space.050'),
});

export const SummaryInfo = styled.div(
  {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'none',
    font: token('font.body.UNSAFE_small'),
  },
  media.upToSmall(`
    display: block;
  `)
);

export const CommentIconWrapper = styled.div({
  display: 'flex',
  marginRight: token('space.050'),
});

export const Byline = styled.small({
  /* Prevents text upscale for small and wide elements in mobile Safari, Edge and Chrome */
  textSizeAdjust: 'none',
});
